export default {
  defaultExample: 0,
  exampleList: [
    `sequence/aggAnim_median.json`,
    `sequence/aggAnim_mean.json`,
    `sequence/agg_filter.json`,
    `sequence/addY_agg.json`,
    `sequence/bin_agg.json`,
    `sequence/usage_scenario_r2d3.json`,
    `sequence/filter_filter.json`,
    `sequence/filter_filter2.json`,
    `sequence/filter_addColor_marktype.json`,
    `sequence/filter_sort.json`,
  ]
};